setTimeout(function() {
    $('#successAlert').alert('close');
}, 3000);